import { useEffect, useState } from 'react'
import { notification } from 'src/components/riders/rider-portal/common/Notification'

type breakpoint = 'sm' | 'md' | 'lg'

const getBreakpoint = (width: number): breakpoint => {
  if (width < 768) {
    return 'sm'
  } else if (width < 990) {
    return 'md'
  } else {
    return 'lg'
  }
}

export const useBreakpoint = (): breakpoint => {
  const [breakpoint, setBreakpoint] = useState<breakpoint>(() => getBreakpoint(window.innerWidth))

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(getBreakpoint(window.innerWidth))
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return breakpoint
}

export const useCurrentLocation = () => {
  const [coordinates, setCoordinates] = useState<google.maps.LatLngLiteral | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!('geolocation' in navigator)) {
      setError('Geolocation is not supported by your browser.')
      return
    }

    navigator.geolocation.getCurrentPosition(
      position => {
        const { latitude, longitude } = position.coords
        setCoordinates({ lat: latitude, lng: longitude })
      },
      err => {
        const message = err.message || 'Unable to retrieve location.'
        setError(message)
        notification({ color: 'danger', message })
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    )
  }, [])

  return { coordinates, error }
}



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/hooks/index.ts